<div class="mat-typography editor-view">
  <tiptap-editor
    *ngIf="editor$ | async as editor"
    class="editor-content"
    outputFormat="json"
    [editor]="editor"
  />
</div>
